import useMerchantPortalAxios, {useMerchantPortalFormData} from "../utils/axios";
import {useState} from "react";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import {setFlag} from "../features/responseSlice";
import {useDispatch} from "react-redux";

const getCleanRequestCorporateCardPayload = (payload = {}) => {
    const mobileNo =
        String(payload.MobileNo || "").trim() ||
        String(payload.PhoneNumber || "").trim() ||
        String(payload.MobileNumber || "").trim();

    const cleanPayload = {
        SessionID: payload.SessionID || sessionStorage.getItem("SessionID"),
        MobileNo: mobileNo,
        NameOnCard: payload.NameOnCard,
        Email: payload.Email,
        LimitPerTransaction: payload.LimitPerTransaction,
        LimitPerMonth: payload.LimitPerMonth,
        CashWithdrawals: payload.CashWithdrawals,
        OnlinePayments: payload.OnlinePayments,
        POSPayments: payload.POSPayments,
        CardProductTypeId: payload.CardProductTypeId,
        AuthorizationCode: payload.AuthorizationCode,
    };

    return Object.fromEntries(
        Object.entries(cleanPayload).filter(([, value]) => value !== undefined)
    );
};

const useCardsAPI = () => {
    const [corporateCards, setCorporateCards] = useState([]);
    const [cardInfo, setCardInfo] = useState([]);
    const [cardsLoading, setCardsLoading] = useState(true);
    const [cardTransactions, setCardTransactions] = useState([]);
    const [cardTransactionsLoading, setCardTransactionsLoading] = useState(true);
    const [totalNbOfPage, setTotalNbOfPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [cardHolderData, setCardHolderData] = useState([]);

    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxios1 = useMerchantPortalFormData();

    const dispatch = useDispatch();

    const GetCorporateCard = async () => {
        setCardsLoading(true)
        const req = new BaseRequest(sessionStorage.getItem("SessionID"));

        await MerchantPortalAxios.post(
            '/v1/Cards/GetCorporateCard',
            req
        ).then((res) => {
            setCorporateCards(res.data.Payload.CorporateCards);
            setCardsLoading(false);
        });
    }

    const GetCardInfoByMobileNo = async (mobileNo) => {
        await MerchantPortalAxios.post(
            '/v1/Cards/GetCardInfoByMobileNo',
            {
                "SessionID": sessionStorage.getItem("SessionID"),
                "MobileNo": mobileNo
            }
        ).then((res) => {
            setCardInfo(res.data.Payload);
            setCardsLoading(false);
        });
    }

    const RequestCorporateCard = async (payload) => {
        const cleanPayload = getCleanRequestCorporateCardPayload(payload);
        console.log("[RequestCorporateCard] final payload", cleanPayload);

        const res = await MerchantPortalAxios.post(
            '/v1/Cards/RequestCorporateCard',
            cleanPayload
            );
        return res.data.Payload;
    }

    const EditCorporateCard = async (payload) => {
        const res = await MerchantPortalAxios.post(
            '/v1/Cards/EditCorporateCard',
            payload
        );
        return res.data.Payload;
    }

    const ActivateDeactivateCorporateCard = async (payload) => {
        const res = await MerchantPortalAxios.post(
            '/v1/Cards/ActivateDeactivateCorporateCard',
            payload
        );
        return res.data.Payload;
    }

    const CancelCorporateCard = async (payload) => {
        const res = await MerchantPortalAxios.post(
            '/v1/Cards/CancelCorporateCard',
            payload
        );
        return res.data.Payload;
    }

    const GetCardTransactions = async (cardId, cardHolderName, CardMSId, page, startDateString, endDateString ) => {
        setCardTransactionsLoading(true);
        const res = await MerchantPortalAxios.post(
            '/v1/Cards/GetCardTransactions',
            {
                "SessionID": sessionStorage.getItem("SessionID"),
                "CardID": cardId,
                "CardHolderName": cardHolderName,
                "CardMSID": CardMSId,
                "page": page,
                "pageSize": 10,
                "DateFrom": startDateString,
                "DateTo": endDateString
            }
        ).then((res) => {
            setCardTransactions(res.data.Payload.CardTransactions);
            setCardTransactionsLoading(false);
            if (res.data.Payload.CardTransactions?.length===0){
                setTotalNbOfPage(0);
                setTotalCount(0);
            }else{
                setTotalNbOfPage(res.data.Payload.CardTransactions[0].TotalPages);
                setTotalCount(res.data.Payload.CardTransactions[0].TotalCount);
            }
        });
    }

    const UploadCardTransactionInvoice = async (payload) => {
        if (payload.ReasonFile) {
            const fileData = payload.ReasonFile.split(',')[1];
            const mimeType = payload.ReasonFile.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            const file = new File([byteArrays], payload.ReasonFileName, { type: mimeType });
            payload.ReasonFile = file;
        }
        await MerchantPortalAxios1.post(
            `/v1/Cards/UploadCardTransactionInvoice`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                TransactionID: payload.TransactionID,
                ReasonFile: payload.ReasonFile
            }
        ).then((res) => {
            if(res.data.Payload.Flag === 0){
                dispatch(setFlag(0));
            };
        });
    };

    const GetCardHolderData = async () => {
        const req = new BaseRequest(sessionStorage.getItem("SessionID"));

        await MerchantPortalAxios.post(
            '/v1/Cards/GetCardHolderData',
            req
        ).then((res) => {
            setCardHolderData(res.data);
        });
    };


    return {
        GetCorporateCard,
        corporateCards,
        cardsLoading,
        GetCardInfoByMobileNo,
        cardInfo,
        RequestCorporateCard,
        EditCorporateCard,
        ActivateDeactivateCorporateCard,
        CancelCorporateCard,
        GetCardTransactions,
        cardTransactions,
        cardTransactionsLoading,
        totalNbOfPage,
        totalCount,
        UploadCardTransactionInvoice,
        GetCardHolderData,
        cardHolderData
    }
};

export default useCardsAPI;
